import React, { useState } from "react";
import "./styles.less";
import { useWindowScroll } from "react-use";
import classnames from "classnames";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

export const Notice = (props) => {
  const { t } = useTranslation();
  let { value = t("common.formNotice") } = props;
  const nav = useNavigate();
  const [visible, setVisible] = useState(true);
  // const [content] = useState(value);
  const { y = 0 } = useWindowScroll();
  const cls = classnames({
    "authing-notice": true,
    "notice-disappear": !visible,
    //   !visible || (typeof window !== "undefined" && window.localStorage["authing://global-notice"] === "20200916"),
    // "notice-hidden": y > 60,
  });
  return (
    <div className={cls}>
      <div className="inner">
        <div className="content">
          <div className="bg-icon-left">
            <img
              src="//files.authing.co/authing-website/notice-icon-left.png"
              alt="authing"
            ></img>
          </div>
          <span className="content-text">
            {/* <i className="icon authing-icon authing-guanbi authing-tongzhi icon-notice"></i> */}
            <span>{value}</span>
            <div
              className="get-button"
              onClick={() => {
                // nav("/authingform");
                window.open("https://host.huiju.cool/p/b1e3e");
              }}
            >
              {t("common.startedFree")}
              <i className="icon authing-icon authing-arrow-right-s-line"></i>
            </div>
          </span>
          <div className="bg-icon-right">
            <img
              src="//files.authing.co/authing-website/notice-icon-right.png"
              alt="authing"
            ></img>
          </div>
          {typeof window !== "undefined" && (
            <span
              onClick={() => {
                setVisible(false);
                // window.localStorage.setItem(
                //   "authing://global-notice",
                //   "20200916"
                // );
              }}
            >
              <i className="icon authing-icon authing-guanbi icon-style"></i>
            </span>
          )}
        </div>
      </div>
    </div>
  );
};
